// We're now using the official react-leaflet package
/** @type {import('react-leaflet').MapContainerProps} */
const mapOptions = {
  minZoom: 3,
  maxZoom: 18,
  preferCanvas: true,
  worldCopyJump: true,
};

export default mapOptions;
